<template>
  <div class="kopf" :class="{ 'bg-turkis': einkauf }">
    <notifications></notifications>
    <div class="container-fluid" :style="systemColor()">
      <div class="left-buttons" style="z-index: 5">
        <div class="navbar-button" v-tooltip.hover="$t('global.home')">
          <router-link to="/">
            <font-awesome-icon icon="fa-duotone fa-home" />
          </router-link>
        </div>
        <div class="navbar-button" v-tooltip.hover="$t('global.back')">
          <div tabindex="0" class="clickable" @click="$router.go(-1)">
            <font-awesome-icon icon="fa-regular fa-angle-left" size="lg" />
          </div>
        </div>
        <div class="navbar-button" v-tooltip.hover="$t('global.forward')">
          <div tabindex="0" class="clickable" @click="$router.go(1)">
            <font-awesome-icon icon="fa-regular fa-angle-right" size="lg" />
          </div>
        </div>
        <div class="navbar-button" v-tooltip.hover="$t('global.refresh')">
          <a href="#" @click="handleRefresh()">
            <font-awesome-icon icon="fa-regular fa-sync" />
          </a>
        </div>
      </div>
      <div class="HeaderTitle text-left ml-5" style="padding-left: 150px">
        <span> {{ $CONST("CONFIG").APPNAME }}</span>
        <span style="font-size: 14px; padding-left: 10px"
          >{{ appVersion }}
        </span>
      </div>
      <div class="right-buttons">
        <div
          class="navbar-button"
          v-tooltip.hover="$t('global.people')"
          v-if="
            berechtigungen.m_geschaeftspartner.read &&
            !isDozent &&
            $CONST('CONFIG').APPTYPE != 'DESKA'
          "
        >
          <!-- <router-link to="/geschaeftspartner/personenliste"> -->
          <router-link to="/personenliste">
            <font-awesome-icon icon="fa-duotone fa-user-friends" />
          </router-link>
        </div>

        <div
          class="navbar-button"
          v-tooltip.hover="$t('global.companiesandfarms')"
          v-if="
            berechtigungen.m_geschaeftspartner.read &&
            !isDozent &&
            $CONST('CONFIG').APPTYPE != 'DESKA'
          "
        >
          <!-- <router-link to="/geschaeftspartner/firmenliste"> -->
          <router-link to="/unternehmensliste">
            <font-awesome-icon icon="fa-duotone fa-building" />
          </router-link>
        </div>

        <div
          class="navbar-button"
          v-tooltip.hover="$t('global.navbar_invoices')"
          v-if="
            berechtigungen.m_finanzen.read &&
            $CONST('CONFIG').APPTYPE != 'DESKA'
          "
        >
          <router-link :to="{ name: 'auftraege' }">
            <font-awesome-icon icon="fa-duotone fa-file-invoice-dollar" />
          </router-link>
        </div>

        <div
          class="navbar-button"
          v-tooltip.hover="$t('global.navbar_correspondence')"
          v-if="
            berechtigungen.m_korrespondenz.read &&
            $CONST('CONFIG').APPTYPE != 'DESKA'
          "
        >
          <router-link :to="{ name: 'korrespondenz-liste' }">
            <font-awesome-icon icon="fa-duotone fa-print" />
          </router-link>
        </div>

        <div
          class="navbar-button"
          v-tooltip.hover="$t('global.emails')"
          v-if="
            berechtigungen.m_korrespondenz.read &&
            $CONST('CONFIG').APPTYPE != 'DESKA'
          "
        >
          <router-link :to="{ name: 'mail-liste' }">
            <font-awesome-icon icon="fa-duotone fa-envelope-open-text" />
          </router-link>
        </div>

        <div
          class="navbar-button"
          v-tooltip.hover="$t('global.navbar_registrations')"
          v-else-if="
            berechtigungen.m_anmeldungen.read &&
            $CONST('CONFIG').APPTYPE != 'DESKA' &&
            !(
              baseURL === 'https://skjv.bx-education.ch' ||
              'https://skjv-dev.bx-education.ch' ||
              'https://skjv-test.bx-education.ch'
            )
          "
        >
          <router-link :to="{ name: 'anmeldungen-liste' }">
            <font-awesome-icon icon="fa-duotone fa-sign-in-alt" />
          </router-link>
        </div>

        <div class="usersign" style="padding-left: 10px; top: 11px"></div>

        <SwitchLanguage />

        <div class="navbar-button" v-tooltip.hover="$t('global.help')">
          <a :href="noHelpAvailable ? noHelpURL : helpURL" target="_blank">
            <font-awesome-icon icon="fa-duotone fa-question-circle" />
          </a>
        </div>

        <div
          class="navbar-button"
          v-if="
            berechtigungen.g_einstellungen.read &&
            $CONST('CONFIG').APPTYPE != 'DESKA'
          "
          v-tooltip.hover="$t('global.settings')"
        >
          <router-link to="/einstellungen/dashboard">
            <font-awesome-icon icon="fa-duotone fa-sliders-v-square" />
          </router-link>
        </div>

        <div class="navbar-button" v-tooltip.hover="$t('global.logout')">
          <div tabindex="0" class="clickable" @click="logout()">
            <font-awesome-icon icon="fa-duotone fa-door-open" />
          </div>
        </div>

        <div class="processbutton">
          <b-button
            size="sm"
            variant="outline-light"
            v-tooltip.hover="$t('global.processes')"
            @click="openSideBar"
          >
            <font-awesome-icon
              aria-hidden="true"
              icon="fa-duotone fa-sidebar-flip"
              size="2x"
            />
          </b-button>
          <div v-if="anzahlLaufendeProzesslaeufe">
            {{ anzahlLaufendeProzesslaeufe }}
          </div>
        </div>

        <div class="usersign" style="padding-left: 25px; margin-right: -6px">
          <div class="dropdown show">
            <a
              href=""
              v-tooltip.hover="$t('global.profile')"
              class="none-decoration"
              role="button"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <font-awesome-icon
                aria-hidden="true"
                icon="fa-duotone fa-user"
                style="margin-bottom: 0.35rem"
                size="2x"
              />
              <span>{{ name }}</span>
            </a>
            <div
              class="dropdown-menu"
              style="
                background-color: #124862;
                margin-left: 0px;
                margin-top: 5px;
                border-radius: 0 0 5px 5px;
              "
              aria-labelledby="dropdownMenuLink"
            >
              <a
                href=""
                class="dropdown-item"
                data-toggle="modal"
                data-target="#passwort-aendern-modal"
              >
                <span>{{ $t("global.passwordchange") }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <passwort-aendern-modal
      id="passwort-aendern-modal"
      @success="showSuccessNotification"
    >
    </passwort-aendern-modal>

    <prozess-sidebar-modal></prozess-sidebar-modal>
  </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
import server from "../server";
import PasswortAendernModal from "@/components/Modals/PasswortAendernModal";
import SwitchLanguage from "@/components/SwitchLanguage.vue";
import helpUrlMap from "../mixins/helpUrlMap";
import packageJson from "../../package.json";
import ProzessSidebarModal from "@/newviva/components/Modale/ProzessSidebarModal";

export default {
  name: "Navbar",
  components: {
    PasswortAendernModal,
    SwitchLanguage,
    ProzessSidebarModal,
  },
  mixins: [helpUrlMap],
  props: {
    icon: { type: String, default: null },
    einkauf: { type: Boolean, default: false },
    finanzen: { type: Boolean, default: false },
    erinnerungConfig: {
      type: Object,
      default: () => {
        return { url: "", titel: "" };
      },
    },
    docsName: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      noHelpAvailable: false,
      baseURL: this.$CONST("CONFIG").BASEURL,
      isDozent: false,
      appVersion: packageJson.version,
      anzahlLaufendeProzesslaeufe: null,
    };
  },
  store,
  computed: {
    name() {
      return this.$store ? this.$store.getters.name : "";
    },
    artikeltypen() {
      return this.$store.state.artikeltypen;
    },
    logoutUrl() {
      if (process.env.NODE_ENV === "development") {
        return `${server.url}/logout/`;
      } else {
        return "/logout/";
      }
    },
    helpURL() {
      if (this.docsName && this.docsName in this.helpUrlMap) {
        return this.helpUrlMap[this.docsName];
      } else {
        return this.noHelpURL;
      }
    },
  },
  created() {
    if (
      this.gruppen.find(
        (gruppe) =>
          gruppe.id == this.$CONST("GRUPPEN").INSTRUCTOR ||
          gruppe.id == "1774DD1D796" // Dozentengruppe
      )
    )
      this.isDozent = true;
  },
  mounted() {
    this.$bus.$on("number-processes", (anzahl) => {
      this.anzahlLaufendeProzesslaeufe = anzahl;
    });
  },
  beforeDestroy() {
    this.$bus.$off("number-processes");
  },
  methods: {
    async logout() {
      try {
        await axios.post(this.logoutUrl, {});
        window.location.href = "/";
      } catch (error) {
        console.log(error);
      }
    },
    showSuccessNotification() {
      this.$notify({
        type: "success",
        title: this.$t("global.actionsuccessful"),
        text: this.$t("global.thepasswordhasbeenchanged"),
      });
    },
    systemColor() {
      switch (this.$CONST("CONFIG").ENVIRONMENT) {
        case "DEV":
          return "background-color: #341C57";
        case "TEST":
          return "background-color: #1c6c65";
        default:
          return "background-color: #124862";
      }
    },
    handleRefresh() {
      // aktuellen Pfad neu laden
      window.location.reload(true);
    },
    openSideBar() {
      this.$bus.$emit("prozess-sidebar-modal-show");
    },
  },
};
</script>

<style lang="scss">
.bm-item-list {
  margin-left: 5%;
}
</style>
